import type { Plugin } from 'vue';

const envPlugin: Plugin = {
  install: (app) => {
    app.config.globalProperties.$env = env;
  },
};

export { envPlugin };
